// extracted by mini-css-extract-plugin
export default {"chef_house":"SakeItem_chef_house__3q8TE","SakeItem":"SakeItem_SakeItem__GdVaa","title":"SakeItem_title__Sp536","selected":"SakeItem_selected__shmQ9"};